import { useFormContext } from 'react-hook-form';
import { useProjectAlertsContext } from '../../context';
import { BulkUpdateOption } from '../../modals/UpdateAlertsModal/AlertBulkUpdateSettings';
import { AlertsFormState } from '../../types';
import { useUpsertProjectCampaignAlertsMutation } from '../useUpsertProjectCampaignAlerts';
import { getUpdateAlertsPayload } from './useUpdateAlerts.utils';

export const useUpdateAlerts = () => {
  const { isLoading, updateAlerts: mutate } = useUpsertProjectCampaignAlertsMutation();
  const { savedAlerts, allAlertMetrics } = useProjectAlertsContext();
  const {
    formState: { dirtyFields },
  } = useFormContext();

  const updateAlerts = (values: AlertsFormState, bulkUpdateSetting: BulkUpdateOption) => {
    const variables = getUpdateAlertsPayload({
      values,
      allAlertMetrics,
      dirtyFields,
      savedAlerts,
      bulkUpdateSetting,
    });

    mutate({ variables });
  };

  return { isLoading, updateAlerts };
};
